<script>
import lodash from "lodash";

export default {
  props: {
    remotePath: {
      type: String,
      default: "",
    },
    callbackBeforeSubmit: {
      type: Function,
      default: () => {},
    },
    callbackAfterSubmit: {
      type: Function,
      default: () => {},
    },
    renameFile: {
      type: String,
    },
    hiddenFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file: null,
      fileName: null,
      dotExtension: null,
      pathCleaned: null,
      isSaveFile: false,
      uploading: false,
      waitSmarter: false,
    };
  },
  computed: {
    pathAfterSaveInRemote() {
      if (this.isSaveFile) {
        return (
          "https://www.helexiumfiles.com/" +
          this.pathCleaned +
          "/" +
          this.fileName +
          this.dotExtension
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    cleanText(fileName) {
      let limpio = lodash.deburr(fileName); // Quita tildes
      limpio = limpio.replace(/\s+/g, "-"); // Reemplaza espacios por guiones
      limpio = limpio.replace(/[^a-zA-Z0-9-_.]/g, ""); // Quita caracteres raros
      return limpio.toLowerCase(); // Pasa a minúsculas
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    handleDrop(event) {
      const selectedFile = event.dataTransfer.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    validateAndProcessFile(file) {
      // si pasa todas las validaciones
      this.file = file;
      const indexLastDot = file.name.lastIndexOf(".");
      this.fileName = file.name.substring(0, indexLastDot);
      this.dotExtension = file.name.substring(indexLastDot);
      this.$emit("rename", this.fileName);

      this.$emit("fileInCache", this);
    },

    async saveInSmarter() {
      if (this.renameFile) {
        this.fileName = this.renameFile;
      }

      this.fileName = this.cleanText(this.fileName);
      this.waitSmarter = true;
      this.pathCleaned = this.remotePath;
      const remoteFormatPath = this.pathCleaned.split("/").join("|");

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("remoteFilePath", remoteFormatPath);
      formData.append("FileName", this.fileName + this.dotExtension);
      formData.append("fileType", this.file.type);

      try {
        const response = await this.$store.dispatch("hl_post_file_axios", {
          path: "CargaMultimedia/UploadFile",
          data: formData,
        });

        if (response && response.respuesta) {
          this.isSaveFile = true;
        } else {
          this.isSaveFile = false;
          throw new Error(response?.mensaje || "Error al subir el archivo");
        }
      } catch (error) {
        console.error("Error al subir archivo:", error);
        this.isSaveFile = false;
        throw error;
      } finally {
        this.waitSmarter = false;
      }
    },

    async onSubmit() {
      if (!this.file) {
        alert("No se ha cargado un documento");
        return;
      }

      this.uploading = true;

      try {
        await this.callbackBeforeSubmit(this);
        await this.saveInSmarter();
        await this.callbackAfterSubmit(this);
        this.onCancel();
      } catch (error) {
        console.error("Error en onSubmit:", error);
        // Mostrar mensaje de error al usuario
        if (this.$swal) {
          this.$swal.fire({
            icon: "error",
            title: "Error al subir archivo",
            text:
              error.message ||
              "No se pudo subir el archivo. Inténtalo de nuevo.",
            confirmButtonText: "Entendido",
          });
        } else {
          alert(
            "Error al subir archivo: " + (error.message || "Error desconocido")
          );
        }
      } finally {
        this.uploading = false;
      }
    },
    onCancel() {
      this.file = null;
      this.fileName = null;
      this.dotExtension = null;
      this.pathCleaned = null;
      this.isSaveFile = false;
      this.$emit("rename", this.fileName);
    },
  },
};
</script>

<template>
  <form @submit.prevent="onSubmit">
    <input
      @change="handleFileChange"
      type="file"
      ref="fileInput"
      style="display: none"
    />
    <slot name="header">
      <div class="header"></div>
    </slot>
    <div class="body">
      <slot> </slot>
      <slot
        name="dropzone"
        :triggerFileInput="triggerFileInput"
        :handleDrop="handleDrop"
      >
        <div
          class="dropzone"
          :class="{ 'has-file': file }"
          @click="triggerFileInput"
          @drop.prevent="handleDrop"
          @dragover.prevent
          @dragenter.prevent
        >
          <div class="content-dropzone" v-if="!waitSmarter">
            <i
              :class="file ? 'ti ti-file-check' : 'ti ti-cloud-up'"
              style="font-size: 1.5rem"
            ></i>
            <span>{{ file ? fileName + dotExtension : "Cargar archivo" }}</span>
          </div>
          <div v-else class="content-dropzone">Guardando...</div>
        </div>
      </slot>
    </div>
    <slot name="footer">
      <div class="footer" v-if="!hiddenFooter">
        <vs-button class="slot-button" type="submit" :loading="uploading"
          >Guardar</vs-button
        >
        <slot name="btn-cancel" :onCancel="onCancel">
          <vs-button class="slot-button" @click.prevent="onCancel" danger
            >Cancelar</vs-button
          >
        </slot>
      </div>
    </slot>
  </form>
</template>

<style>
.dropzone {
  width: 150px;
  height: 150px;
  border: 1px dashed #ccc;
  /* .dark & {
    border: 2px dashed rgba(255, 255, 255, 0.1);
  } */
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  transition: all 0.3s ease;
}

.dropzone.has-file {
  border-color: #00b894;
  background-color: rgba(0, 184, 148, 0.1);
  border-width: 2px;
}

.dropzone:hover:not(.has-file) {
  background-color: rgba(0, 0, 0, 0.3);

  .dark & {
    background-color: rgba(255, 255, 255, 0.3);
  }
}

.dropzone.has-file:hover {
  background-color: rgba(0, 184, 148, 0.2);
}

.content-dropzone {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* color: #fff; */
  padding-inline: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  & span {
    /* color: #fff; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.dropzone.has-file .content-dropzone {
  color: #00b894;
  font-weight: 500;
}

.footer {
  display: flex;
  margin-top: 1rem;
  gap: 0.5rem;
}

.slot-button {
  margin: 0;
}
</style>
